import { Box, Chip, Typography } from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";

// Which branches the orders list is limited to (legacy trade-delay roles).
const BranchContextBanner = ({ branchContext, isEmployee }) => {
  if (!branchContext?.branches?.length) return null;
  return (
    <Box
      mb={2}
      px={2}
      py={1.5}
      sx={{
        bgcolor: "#f0f7ff",
        border: "1px solid #bdd7f5",
        borderRadius: 2,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <StoreIcon sx={{ color: "#0054A5", mt: 0.3, flexShrink: 0 }} />
      <Box>
        <Typography variant="body2" fontWeight={600} color="#0054A5">
          {isEmployee
            ? `מציג הזמנות עבור סניפי המנהל: ${branchContext.managerName || ""}`
            : "מציג הזמנות עבור הסניפים שלי"}
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
          {branchContext.branches.map((b) => (
            <Chip key={b} label={b} size="small" sx={{ bgcolor: "#dbeafe", color: "#1e40af", fontSize: "0.75rem" }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BranchContextBanner;
